export type RuntimeConfig = {
  sentryDsn?: string;
  sentryTracesSampleRate?: string;
  sentryEnvironment?: string;
  sentryRelease?: string;
};

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
    SENTRY_RELEASE?: { id?: string };
  }
}

export const resolveRuntimeValue = (
  runtimeValue: string | undefined,
  buildTimeValue: string | undefined,
): string | undefined =>
  typeof runtimeValue === 'string' && runtimeValue.trim() !== '' ? runtimeValue : buildTimeValue;

export const toSentrySampleRate = (raw: string | undefined): number => {
  const rate = Number(raw);
  return Number.isFinite(rate) && rate >= 0 && rate <= 1 ? rate : 0;
};

const runtimeOverride =
  (typeof window === 'undefined' ? undefined : window.__RUNTIME_CONFIG__) ?? {};
const buildTimeRelease = typeof window === 'undefined' ? undefined : window.SENTRY_RELEASE?.id;

export const sentryDsn = resolveRuntimeValue(
  runtimeOverride.sentryDsn,
  import.meta.env.VITE_SENTRY_DSN,
);
export const sentryTracesSampleRate = toSentrySampleRate(
  resolveRuntimeValue(
    runtimeOverride.sentryTracesSampleRate,
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  ),
);
export const sentryEnvironment = resolveRuntimeValue(
  runtimeOverride.sentryEnvironment,
  import.meta.env.SENTRY_ENV,
);
export const sentryRelease = resolveRuntimeValue(runtimeOverride.sentryRelease, buildTimeRelease);
